import { API } from "@infra/implementations/api";
import type { Company } from "@domain/company";
import type { User } from "@domain/user";
import { CompaniesUseCase } from "@app/company/CompaniesUseCase";

export const companiesUseCase = new CompaniesUseCase({
	getCompaniesByUser: (user: User) => API.Data.Companies.get.byUser(user) as Promise<Company[]>,
});
